  <div class="unauthorized-container">
    <mat-card class="unauthorized-card">
      <mat-card-content>
        <div class="unauthorized-content">
          <span class="material-symbols-outlined unauthorized-icon">block</span>
          <h2>{{ 'unauthorized_text' | translate }}</h2>
          <p>{{ 'unauthorized' | translate }}</p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
